module.exports = __webpack_public_path__ + "static/img/payment-third-2-1x.4c4aac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-third-2-1x.png
// module id = dcCb
// module chunks = 12